// removed by extract-text-webpack-plugin
module.exports = {"paper-box":"styles-module__paper-box___14PxS","paper-title":"styles-module__paper-title___3Boc8","float-right":"styles-module__float-right___ukx3L","delete-seed":"styles-module__delete-seed___1tLxc","author-year":"styles-module__author-year___2nceY","journal":"styles-module__journal___3i5cq","linkout-icon":"styles-module__linkout-icon___2q_Nq","selected-paper":"styles-module__selected-paper___1hDG0","stroke1":"styles-module__stroke1___2i3aI","fill1":"styles-module__fill1___3Rxuc"};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/PaperCard/styles.module.css
// module id = 409
// module chunks = 0